module.exports = __webpack_public_path__ + "static/media/camzyos_android_pass.80aab5b2.svg";